import { ServiceTypes } from "pages/ViewProperty/components/PropertyProfile/components/AnalysisSection/components/PricingAnalysis/constants";
import { apiClient } from "lib/apiClient";

export type TAvgRentByCareType = Record<ServiceTypes, number | null>;

export interface IAssetDashboardKpi {
  propertyCount: number;
  unitCount: number;
  avgCompAgeDays: number | null;
  avgOccupancyPercent: number | null;
  avgRentByCareType: TAvgRentByCareType;
}

export interface IOccupancyEntry {
  name: string;
  occupiedNum: number | null;
  totalUnits: number | null;
  occupancyPercent: number | null;
  isSubject: boolean;
}

export const OCCUPANCY_TOTAL_KEY = "total";

export type TOccupancyData = {
  total: IOccupancyEntry[];
  activeAdult: IOccupancyEntry[];
  independentLiving: IOccupancyEntry[];
  assistedLiving: IOccupancyEntry[];
  memoryCare: IOccupancyEntry[];
  skilledNursing: IOccupancyEntry[];
};

export type TOccupancyKey = keyof TOccupancyData;

export interface IAssetDashboardCompetitor {
  propertyName: string;
  distance: number | null;
  status: string | null;
  units: number | null;
  occupancyPerc: number | null;
  opened: number | null;
  marketArea: string | null;
  compDate: string | null;
}

export interface IAssetDashboardSummary {
  kpi: IAssetDashboardKpi;
  occupancy: TOccupancyData;
  competitiveSet: IAssetDashboardCompetitor[];
}

export const getAssetDashboardSummary = async (
  propertyId: string
): Promise<IAssetDashboardSummary> => {
  const response = await apiClient.get(
    `/property/${propertyId}/asset-dashboard/summary`
  );

  return response.data;
};
